define(function (require) {

    var LPQueue = require('web-agent-utils/LPQueue');
    window.lpTag = window.lpTag || {};

    var PollingManager = function (config) {

        var key = config.key;
        var startCallback = config.startCallback;
        var pauseCallback = config.pauseCallback;
        var resumeCallback = config.resumeCallback;
        var stopCallback = config.stopCallback;
        var pollingContext = config.pollingContext;
        var removeDataCallback = config.removeDataCallback;
        var dataContext = config.dataContext;

        var cachingConstants = {
            maxItemsInMemory: config.maxItemsInMemory || 10,
            itemTimeToLiveInMilliSec: config.itemTimeToLiveInMilliSec || 300000
        };

        var pausedItemsQueue = new LPQueue({key: key});
        var currentTimeout = null;

        function runCallback(callback, data, context) {
            if (callback) {
                if (context) {
                    callback.call(context, data);
                } else {
                    callback(data);
                }
            }
        }

        function startOrResumeItemAndRemoveFromQueue(data) {
            if (data && data[key]) {
                var itemId = {};
                itemId[key] = data[key];
                var item = pausedItemsQueue.getItem(itemId);
                if (item) {
                    runCallback(resumeCallback, data, pollingContext);
                    pausedItemsQueue.removeFromQueue(item);
                } else {
                    runCallback(startCallback, data, pollingContext);
                }
            }
        }

        function setActiveItem(data) {
            startOrResumeItemAndRemoveFromQueue(data);
            if (data && data[key]) {
                clearSizeOverflow();
                clearTimeOverflow();
            }
        }

        function setInactiveItem(data) {
            // Here we call "pauseCallback". Only the "clear" can call "stopCallback".
            // Then we add the key with the current timestamp to the queue
            if (data && data[key]) {
                var item = {timestamp: getCurrentTime()};
                item[key] = data[key];
                runCallback(pauseCallback, data, pollingContext);
                // making sure this item is not part of the queue already.
                removeItemById(item[key]);
                pausedItemsQueue.enqueue(item);
                clearSizeOverflow();
                clearTimeOverflow();
            }
        }

        function clearTimeOverflow() {
            // Here we clear items from the queue that have expired
            // This method peeks into the queue, and checks the timestamp.
            // If it's expired - we call "stopCallback" and remove it from the queue.
            // We continue until we reach a timestamp that's not expired.
            // We call a timeout with the time left until the timestamp expires
            // The timeout has this function as the callback
            // On every interruption we clear the timeout and re-calculate
            if (currentTimeout) {
                clearTimeout(currentTimeout);
                currentTimeout = null;
            }
            if (!pausedItemsQueue.isEmpty()) {
                var item = pausedItemsQueue.peek();
                var timeLeft = getTimeLeft(item);
                while (typeof timeLeft !== 'undefined' && timeLeft < 0 && !pausedItemsQueue.isEmpty()) {
                    removeItem();
                    item = pausedItemsQueue.peek();
                    timeLeft = getTimeLeft(item);
                }
                if (typeof timeLeft !== 'undefined' && timeLeft >= 0 && !pausedItemsQueue.isEmpty()) {
                    currentTimeout = setTimeout(clearTimeOverflow, timeLeft);
                }
            }
        }

        function getTimeLeft(item) {
            var timeLeft;
            if (item && item.timestamp) {
                timeLeft = cachingConstants.itemTimeToLiveInMilliSec - getCurrentTime() + item.timestamp;
            }
            return timeLeft;
        }

        function getCurrentTime() {
            return new Date().getTime();
        }

        function clearSizeOverflow() {
            // Here we will clear items from the queue if the queue is longer than the maximum limit
            while (pausedItemsQueue.size() > cachingConstants.maxItemsInMemory) {
                removeItem();
            }
        }

        function removeItem() {
            var item = pausedItemsQueue.dequeue();
            if (item && item[key]) {
                var itemId = {};
                itemId[key] = item[key];
                runCallback(stopCallback, itemId, pollingContext);
                //remove this item from web agent model
                runCallback(removeDataCallback, itemId, dataContext);
            }
        }

        function removeItemById(id) {
            if (id) {
                var itemId = {};
                itemId[key] = id;
                var item = pausedItemsQueue.getItem(itemId);
                // If the item exists - remove it. If not - do nothing.
                if (item && item[key]) {
                    pausedItemsQueue.removeFromQueue(item);
                }
            }
        }

        return {
            setActiveItem: setActiveItem,
            setInactiveItem: setInactiveItem,
            removeItemById: removeItemById
        };
    };

    return PollingManager;

});
